import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { IMG } from "@/lib/images";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { BookConsultation } from "@/components/BookConsultation";
import { SEO } from "@/components/SEO";
import { pageSEO } from "@/lib/seo";
import { useLang } from "@/i18n/LanguageContext";

export default function Services() {
  const { c, lang } = useLang();
  const s = c.pages.services;
  const nums = ["01", "02", "03", "04", "05", "06"];
  return (
    <div data-testid="services-page">
      <SEO {...pageSEO("services", lang)} path="/services" lang={lang} image={IMG.interior} />
      <PageHeader eyebrow={s.eyebrow} lines={s.hLines} title="Services" subtitle={s.subtitle} image={IMG.interior} />

      <section className="py-24 lg:py-32 bg-olime-bg">
        <div className="container-olime grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {s.items.map((item, i) => (
            <Reveal key={item.title} delay={(i % 2) * 0.1}>
              <div data-testid={`service-${i}`} className="group bg-white border border-olime-line p-10 lg:p-12 h-full transition-shadow duration-500 hover:shadow-[0_20px_60px_rgba(0,0,0,0.06)]">
                <span className="font-serif text-4xl text-olime-sand">0{i + 1}</span>
                <h3 className="font-serif text-3xl md:text-4xl mt-4">{item.title}</h3>
                <ul className="mt-8 space-y-4">
                  {item.list.map((it) => <li key={it} className="flex items-center gap-3 text-olime-muted"><Check size={15} className="text-olime-stone" /> {it}</li>)}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="container-olime text-center mt-16">
          <Reveal><Link to="/contact#form" data-testid="services-quote-cta" className="btn-ink">{c.cta.quote} <ArrowRight size={14} /></Link></Reveal>
        </div>
      </section>

      <section className="py-24 lg:py-32 bg-white" data-testid="services-outdoor">
        <div className="container-olime grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <Reveal><span className="eyebrow">{s.outdoor.eyebrow}</span>
              <h2 className="font-serif text-4xl md:text-5xl tracking-tight mt-4">{s.outdoor.title}</h2></Reveal>
            <Reveal delay={0.15}>
              <p className="mt-6 text-olime-muted leading-relaxed">{s.outdoor.text}</p>
              <p data-testid="services-partner-note" className="mt-6 text-sm italic text-olime-muted">{s.partner}</p>
            </Reveal>
          </div>
          <Reveal delay={0.1}><img src={IMG.outdoorBalcony} alt={s.outdoor.title} className="w-full aspect-[3/4] object-cover" /></Reveal>
        </div>
        <div className="container-olime grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 mt-6 lg:mt-8">
          <Reveal><img src={IMG.outdoorHero} alt={s.outdoor.title} className="w-full aspect-[4/3] object-cover" /></Reveal>
          <Reveal delay={0.1}><img src={IMG.outdoorDining} alt={s.outdoor.title} className="w-full aspect-[4/3] object-cover" /></Reveal>
        </div>
      </section>

      <section className="py-24 lg:py-32 bg-olime-bg">
        <div className="container-olime">
          <Reveal><span className="eyebrow">{s.methodEyebrow}</span>
            <h2 className="font-serif text-4xl md:text-6xl tracking-tight mt-3 mb-16">{s.methodTitle}</h2></Reveal>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
            {c.method.steps.map((m, i) => (
              <Reveal key={i} delay={(i % 3) * 0.08}>
                <div className="border-t border-olime-ink pt-6">
                  <span className="font-serif text-3xl text-olime-stone">{nums[i]}</span>
                  <h3 className="font-serif text-2xl mt-2">{m.title}</h3>
                  <p className="text-olime-muted mt-3">{m.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 lg:py-32 bg-olime-manifesto" data-testid="services-book">
        <div className="container-olime text-center max-w-2xl mx-auto">
          <Reveal><span className="eyebrow">O'LIME DESIGN</span>
            <h2 className="font-serif text-4xl md:text-5xl tracking-tight mt-4 mb-10">{c.cta.discuss}</h2></Reveal>
          <Reveal delay={0.1}><BookConsultation variant="ink" testId="services-book-cta" showIcon={true} /></Reveal>
        </div>
      </section>
    </div>
  );
}
